export default __webpack_public_path__ + "static/media/searchIcon.b49d128b.svg";